import { allTrackers } from "app/services/track/track";

import createPremiumFeatureTrackingService from "./factory";

const premiumFeatureTrackingService = createPremiumFeatureTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default premiumFeatureTrackingService;
